import OtpInput from "react-otp-input";
import { z } from "zod";

import "./login.scss";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SwipeableButton } from "react-swipeable-button";
import environment from "environment";
import axios from "axios";
import { API } from "../../service/api-config";
import { ToastContainer, toast } from "react-toastify";

const phoneSchema = z
  .string()
  .min(10, "Phone number must be at least 10 digits")
  .max(10, "Phone number must not exceed 10 digits")
  .refine((val) => /^[6-9]\d{9}$/.test(val), {
    message: "Please enter a valid Indian mobile number",
  });

const Login = () => {
  const navigate = useNavigate();
  const swipeButton = useRef();
  const [otp, setOtp] = useState("");
  const [mobile, setMobile] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [isLoading, setLoading] = useState(false);
  const scannedData = JSON.parse(sessionStorage.getItem("scannedData")) || [];

  const sendOTP = (number) => {
    setLoading(true);
    // axios.get(`${environment.authAPI}/${environment.apiKey}/SMS/+91${number}/AUTOGEN/OTP1`).then(e => {
    //     setSessionId(e.data.Details);
    // }).finally(() => {
    //     setLoading(false)
    // })

    axios
      .post(`${API.LOGIN()}`, {
        mobile: `+91${mobile}`,
      })
      .then((e) => {
        setSessionId(e.data.sessionId);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const validateOTP = (otp) => {
    setLoading(true);
    axios
      .post(API.VERIFY_OTP(), {
        mobile: `+91${mobile}`,
        otp,
        sessionId,
      })
      .then((e) => {
        sessionStorage.setItem("userDetails", JSON.stringify(e.data));
        if(scannedData?.length && scannedData?.length > 4) {
          navigate("/redeem");
        } else {
          navigate("/home");
        }
      })
      .catch((e) => {
        swipeButton.current.buttonReset();
        toast.error(e.response.data.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="app-login">
      <ToastContainer />
      <div className="welcom-container">
        <div className="container px-4  pt-5">
          <h2 className="pb-5 mt-5" style={{ lineHeight: "36px" }}>
            Tell us your
            <br /> mobile number
          </h2>
        </div>
      </div>
      <div className="log-line"></div>
      <div className="container">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            try {
              phoneSchema.parse(mobile);
              sendOTP(mobile);
            } catch (error) {
              toast.error(error.errors[0].message);
            }
          }}
        >
          <div className="input-group mt-5">
            <input
              type="tel"
              value={mobile}
              onChange={({ target: { value } }) => {
                setMobile(value);
              }}
              className="form-control px-4"
              placeholder="Phone Number"
              aria-label="Phone Number"
              aria-describedby="Phone Number"
              required
            />
            <button
              type="submit"
              disabled={isLoading}
              className="input-group-text px-4 font-normal"
              id="basic-addon2"
            >
              {sessionId ? "Sent" : "SEND OTP"}
            </button>
          </div>
          <div className="d-flex justify-start mt-3 gap-2 items-start">
            <input
              className=""
              type="checkbox"
              value=""
              id="flexCheckChecked"
            />
            <label className="font-light text-[10px]" htmlFor="flexCheckChecked">
              Allow Zuno to access your contact information from 
              <span className="text-[10px] font-light text-white" style={{ textDecoration: "underline", marginLeft: "5px" }}>
                your contacts.
              </span>
            </label>
          </div>
        </form>
        <div className="w-100 mt-5 otp-container">
          <label className="text-white fw-bold mb-3">ENTER OTP</label>
          <OtpInput
            containerStyle={{ width: "100%" }}
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span className="px-2" />}
            inputType="tel"
            renderInput={(props) => (
              <input
                {...props}
                className="form-control text-center otp-input"
              />
            )}
          />
          <div className="mt-4">
            <SwipeableButton
              onSuccess={() => {
                if (otp) {
                  validateOTP(otp);
                } else {
                  swipeButton.current.buttonReset();
                }
              }}
              onFailure={() => {}}
              text="Login Now"
              text_unlocked="Loading..."
              sliderColor="#FF6E01"
              sliderTextColor="#ffffff"
              sliderIconColor="#ffffff"
              background_color="#ffffff60"
              thumb={<div>hii</div>}
              borderRadius={30}
              ref={swipeButton}
              circle
              autoWidth
              disabled={isLoading}
              name="react-swipeable-button"
            >
              <div>hii</div>
            </SwipeableButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
